var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFill = function SvgStarFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25.2 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc153",
    d: "M12.6 0 8.719 7.92 0 9.168l6.324 6.144L4.839 24l7.761-4.08L20.361 24l-1.485-8.688L25.2 9.168 16.48 7.92Z"
  })));
};
export default SvgStarFill;